import api from './baseApi'

export function getAll() {
    return api.get(`PaymentLogs`)
}

export function getAllByUser(userId) {
    return api.get(`PaymentLogs/users/${userId}`)
}